export default function() {
    // Mobile navigation (global)
    var nav = document.querySelector('[data-nav]');
    var navTrigger = document.querySelector('[data-nav-trigger]');

    if(navTrigger){
        navTrigger.addEventListener('click', function() {
            navTrigger.classList.toggle('is-active');
            nav.classList.add('drawer--transition');
            nav.classList.toggle('drawer--active');
            document.body.classList.toggle('drawer-active');
        });
    }

    // add class "fixed-top" to table header when they are in the top of the screen
    var table = document.querySelector('table.table-fixed');
    if(table){
        window.addEventListener('scroll', function() {
            var tableHeader = table.querySelector('thead');
            if(tableHeader){
                var tableHeaderRect = tableHeader.getBoundingClientRect();
                if(tableHeaderRect.top <= 0){
                    tableHeader.classList.remove('fixed-top');
                    tableHeader.classList.add('sticky');
                    tableHeader.classList.add('top-12');
                }
                else{
                    tableHeader.classList.add('fixed-top');
                }
            }
        });
    }

    var header = document.querySelector('header');
    if(header){

        window.addEventListener('scroll', function() {
            if(window.pageYOffset > 0){
                header.classList.add('header--scrolled');
            }
            else{
                header.classList.remove('header--scrolled');
            }
        });

    }
}